import React, { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getUserInfo } from "utils/utility";
// getIsUser,
// import useBodyScrollLock from "hooks/useBodyScrollLock";
import { useMutation } from "@tanstack/react-query";
import { getIbsHasIBSHistory } from "apis/ibs";
import useModal from "hooks/useModal";
import PendingModal from "components/Signup/Modal/PendingModal";
import RejectedModal from "components/Signup/Modal/RejectedModal";
import SignupModal from "components/Signup/Modal/SignupModal";
import SignupApproveModal from "components/Signup/Modal/SignupApproveModal";
import IBSTestModal from "components/Signup/Modal/IBSTestModal";

const HeaderLayout = ({ children }: { children: ReactNode }) => {
  const { state } = useLocation();
  // const location = useLocation();

  // const { openScroll, lockScroll } = useBodyScrollLock();

  const {
    isOpen: isOpenPendingModal,
    openModal: openPendingModal,
    closeModal: closePendingModal,
  } = useModal();

  const {
    isOpen: isOpenRejectedModal,
    openModal: openRejectedModal,
    closeModal: closeRejectedModal,
  } = useModal();

  const {
    isOpen: isOpenSignupModal,
    openModal: openSignupModal,
    closeModal: closeSignupModal,
  } = useModal();

  const {
    isOpen: isOpenApproveModal,
    openModal: openApproveModal,
    closeModal: closeApproveModal,
  } = useModal();

  const {
    isOpen: isOpenIBSModal,
    openModal: openIBSModal,
    closeModal: closeIBSModal,
  } = useModal();

  const hadIBSHistoryMutation = useMutation({
    mutationFn: getIbsHasIBSHistory,
    onSuccess: (res) => {
      const { hasIBSHistory, isSubmitted } = res;
      const ibsState = hasIBSHistory
        ? isSubmitted
          ? "DONE"
          : "PROCEEDING"
        : "NULL";

      if (ibsState === "NULL") openApproveModal();
      if (ibsState === "PROCEEDING") openIBSModal();
    },
  });

  useEffect(() => {
    if (state) {
      if (state?.status === "PENDING") openPendingModal();
      if (state?.status === "REJECTED") openRejectedModal();
      if (state?.status === "NOT_REGISTERED") openSignupModal();
      if (state?.status === "APPROVED") {
        const userType = getUserInfo()?.userType;

        if (userType === "HOSPITAL") hadIBSHistoryMutation.mutate();
      }

      localStorage.removeItem("path");
      window.history.replaceState({}, "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  // useEffect(() => {
  //   if (!getIsUser() && location.pathname === "/matching") {
  //     lockScroll();
  //     return;
  //   }

  //   openScroll();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [location.pathname]);

  return (
    <>
      {children}
      {isOpenPendingModal && <PendingModal modalClose={closePendingModal} />}
      {isOpenRejectedModal && <RejectedModal modalClose={closeRejectedModal} />}
      {isOpenSignupModal && <SignupModal modalClose={closeSignupModal} />}
      {isOpenApproveModal && (
        <SignupApproveModal modalClose={closeApproveModal} />
      )}
      {isOpenIBSModal && <IBSTestModal modalClose={closeIBSModal} />}
    </>
  );
};

export default HeaderLayout;
